










































import { Component, Mixins, Vue } from "vue-property-decorator";
import vClickOutside from 'v-click-outside';
import { namespace } from "vuex-class";
import User from "@/model/user";
import userApi from "@/api/userApi";
import store from "@/store";
import updateClassSidebar from "@/mixin/updateClassSidebar.ts";
const auth = namespace("Auth");

@Component({
  name: "QSidebarAadminCustomer",
  directives: {
    clickOutside: vClickOutside.directive,
  }
})
export default class QSidebarAadminCustomer extends Mixins(updateClassSidebar) {
  @auth.Getter
  getUserType!: (token: string) => void;

  public classPage:Array<any> = ["mb__admin-navbox"];

  public created() {
    this.classPage = this.changeClassPage(this.classPage);
  }

  User = new User();
  public async logout() {
    try {
      const result = await userApi.logout();
      if (result.status === 200) {
        store.dispatch("Auth/logout");
      }
    } catch (error) {
      console.log(error);
    }
  }

  public closeMenu(event) {
    this.$emit('closeMenu', event)
  }
}
